export default [
    {
        path: '/contact-us',
        name: 'contact',
        component: () => import('./components/main-view.vue'),
        meta: { 
            title: 'Contact Us'
        }, 
    }
]